module.exports = __webpack_public_path__ + "static/media/8.a4b4a843.jpg";